// import {firebase} from "firebase/compat/app";
// import "firebase/auth";
// import { firestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firecred = {
  apiKey: "AIzaSyCf8LvZcFdEotK2xZ4BPdK-RCQidA0K9CI",
  authDomain: "ab-physics.firebaseapp.com",
  databaseURL:
    "https://ab-physics-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ab-physics",
  storageBucket: "ab-physics.appspot.com",
  messagingSenderId: "859465366515",
  appId: "1:859465366515:web:90cd05c02b3e108606b086",
  measurementId: "G-JPJP5MFQTZ",
};

const app = initializeApp(firecred);
// const auth= firebase.initializeApp(firecred);
const auth = getAuth(app);
const db = getFirestore(app);
const storage=getStorage(app);

export { auth, app, db ,storage};
